import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CHAT_API_BASE_URL } from '../../constants/central-api';

export default async function get_system_instruction_api_call() {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: `${TARA_CHAT_API_BASE_URL}system-prompt`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_SYSTEM_INSTRUCTION';
  const customMsg = 'System instruction fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    return response.data || null;
  }
}
